export type FinanceMonthlyType = {
    key_description: string
    code_budget: string
    budget: string
    budget_id?: number|null
    average: string
    january: number | string | null
    february: number | string | null
    march: number | string | null
    april: number | string | null
    may: number | string | null
    june: number | string | null
    july: number | string | null
    august: number | string | null
    september: number | string | null
    october: number | string | null
    november: number | string | null
    december: number | string | null
    category?: string
    formula?: string
  }

  export type FinanceSuccessFetch = {
    status: string
    responseStatus: number
    message: string
    payload: FinanceMonthlyType[]
  }


  export const persentage_category = [
    "FC_GM",
    "FC_OM",
    "KPI_OMPE",
  ]
